"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decryptString = exports.encryptString = void 0;
const crypto_js_1 = require("crypto-js");
const encryptString = (password, key) => {
    if (!key) {
        throw new TypeError("Missing API key for password encryption");
    }
    return crypto_js_1.AES.encrypt(password, key).toString();
};
exports.encryptString = encryptString;
const decryptString = (value, key) => {
    if (!key) {
        throw new TypeError("Missing API key for password encryption");
    }
    const bytes = crypto_js_1.AES.decrypt(value, key);
    return bytes.toString(crypto_js_1.enc.Utf8);
};
exports.decryptString = decryptString;
